import { connect } from 'react-redux';
import {
  fetchCategories2,
  selectCategory,
  resetCurrentCategory,
  editMultiCategories2,
  deleteCategory2,
  clearCategory2Status,
  fetchGroupCategories,
  fetchCategory2Products,
} from '../../actions/products_actions';

import Category_2 from '../../components/Products/category_2';

function mapStateToProps(state) {
  return {
    categories: state.products.categories2,
    categoryIsLoading: state.products.category2IsLoading,
    categoryError: state.products.category2Error,

    currentCategory: state.products.currentCategory,
    multiIsEditing: state.products.multiCategory2IsEditing,
    multiError: state.products.multiCategory2EditError,
    multiEdited: state.products.multiCategory2Edited,
    userPermissions: state.auth.userPermissions,
    deletingCategory: state.products.deletingCategory2,
    deleteCategorySuccess: state.products.deleteCategory2Success,
    deleteCategoryError: state.products.deleteCategory2Error,
    // currentGroup: state.products.currentGroup,
  };
}

export default connect(mapStateToProps, {
  fetchCategories2,
  selectCategory,
  resetCurrentCategory,
  editMultiCategories2,
  deleteCategory2,
  clearCategory2Status,
  fetchGroupCategories,
  fetchCategory2Products,
})(Category_2);



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/category_2.jsx